module.exports = __webpack_public_path__ + "img/huawei.cbe08bf4.png";